var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initAnnouncementBar = /* @__PURE__ */ __name(($el, $refs) => {
  const initialChildren = [...$el.children];
  const settings = utils.JSONParse(
    $el.getAttribute("data-settings")
  );
  let block_scroll_events = false;
  let timeout = null;
  const children = [...new Array(5)].reduce((acc, _, index) => {
    if (index === 0) {
      return initialChildren;
    }
    if (acc.length < 5) {
      acc = [
        ...acc,
        ...initialChildren.map((child) => {
          const newChild = child.cloneNode(true);
          newChild?.removeAttribute("data-block-id");
          newChild?.removeAttribute("data-shopify-editor-block");
          return newChild;
        })
      ];
    }
    return acc;
  }, [])?.map((child, index, arr) => {
    child.style.order = `${index > arr.length - 3 ? -arr.length + index : index}`;
    return child;
  });
  $el.scrollLeft = $el.clientWidth * 2;
  $el.replaceChildren(...children);
  const handleScroll = /* @__PURE__ */ __name(() => {
    if (block_scroll_events) return;
    resetIndex();
    if ($el.scrollLeft > $el.clientWidth * 3) {
      block_scroll_events = true;
      [...children].sort((a, b) => +a.style.order - +b.style.order).forEach((child, index, arr) => {
        child.style.order = `${index === 0 ? arr.length - 3 : +child.style.order - 1}`;
      });
      $el.scrollLeft = $el.scrollLeft - $el.clientWidth;
      block_scroll_events = false;
    }
    if ($el.scrollLeft < $el.clientWidth) {
      block_scroll_events = true;
      [...children].sort((a, b) => +a.style.order - +b.style.order).forEach((child, index, arr) => {
        child.style.order = `${index === arr.length - 1 ? -2 : +child.style.order + 1}`;
      });
      $el.scrollLeft = $el.scrollLeft + $el.clientWidth;
      block_scroll_events = false;
    }
    children.forEach((el) => {
      const { width, height, left, right } = el.getBoundingClientRect();
      if (width && height && left + width / 2 > 0 && right - width / 2 < $el.clientWidth) {
        el.removeAttribute("tabindex");
        el.querySelectorAll("*").forEach((child) => child.removeAttribute("tabindex"));
      } else {
        el.tabIndex = -1;
        el.querySelectorAll("*").forEach((child) => child.tabIndex = -1);
      }
    });
  }, "handleScroll");
  const resetIndex = /* @__PURE__ */ __name(() => {
    if (!settings.display_duration || block_scroll_events) return;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      block_scroll_events = true;
      $el.classList.remove("snap-x");
      utils.scrollToX(300, $el.scrollLeft + $el.clientWidth, $el, () => {
        [...children].sort((a, b) => +a.style.order - +b.style.order).forEach((child, index, arr) => {
          child.style.order = `${index === 0 ? arr.length - 3 : +child.style.order - 1}`;
        });
        $el.scrollLeft = $el.scrollLeft - $el.clientWidth;
        block_scroll_events = false;
        $el.classList.add("snap-x");
        resetIndex();
      });
    }, settings.display_duration * 1e3);
  }, "resetIndex");
  const handleEditorBlockSelect = /* @__PURE__ */ __name((sectionId = "", blockId) => {
    const focusChild = children.find((el) => el.getAttribute("data-style-id") === `${sectionId}--${blockId}`)?.closest("[data-announcement]");
    $el.classList.toggle("!overflow-hidden", !!focusChild);
    $el.classList.toggle("snap-x", !focusChild);
    block_scroll_events = !!focusChild;
    if (focusChild) {
      $el.scrollLeft = focusChild?.offsetLeft;
      clearTimeout(timeout);
      timeout = null;
    } else {
      if (!timeout && settings.display_duration) {
        resetIndex();
      }
    }
  }, "handleEditorBlockSelect");
  resetIndex();
  return {
    handleScroll,
    resetIndex,
    handleEditorBlockSelect
  };
}, "initAnnouncementBar");
window._sections["initAnnouncementBar"] = initAnnouncementBar;
